import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { PermisionGroupProfiles } from './master-consulta-perfil.models';
const BASE_PATH = environment.basePath;
@Injectable({
  providedIn: 'root',
})
export class MasterConsultaProfileService {
  constructor(private _$http: HttpClient) {}

  getProfiles(payload: any): Observable<any> {
    return this._$http.post<any>(
      `${BASE_PATH}/bff/master/access-profile/profiles/list`, payload);
  }

  getProfileSearch(payload: string) {
    return this._$http
      .post<any>(
        `${BASE_PATH}/bff/master/access-profile/profiles/list`, payload)
      .toPromise();
  }
}
